module.exports = __webpack_public_path__ + "static/media/Star.cbd52aff.svg";